import { Component, AfterViewInit, DoCheck, ElementRef, ViewChild, OnChanges, Input, Output, EventEmitter } from '@angular/core';

//この機能を確認
import { GridOptions } from 'ag-grid';

//この処理を確認
import * as encoding from 'encoding-japanese';
import { NSuppService } from '../../../service/nsupp/nsupp.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'wa5030',
  templateUrl: 'wa5030.component.html',
  styleUrls: ['wa5030.component.scss']
})
export class Wa5030Component implements AfterViewInit, DoCheck, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA5030:通常補充指示作成';
  public owners: any;
  public ownerId: number = 0;
  public gridOptions: GridOptions;
  public showGrid = false;
  public rowData: any[];
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public errorInfo: string = '';
  private selectedCount: number;

  private otherwindowdspnone: boolean = true;
  private loadingdspnone: boolean = true;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private isEnableClearFilter = false;
  private isShowGridNoDataOverlay = false;
  private ownerFormControl: FormControl;
  private ownerFormControlCls = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  constructor(private ownerService: OwnerService, private nsuppService: NSuppService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      // domLayout: "autoHeight",
      pagination: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5030_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.autoTogglePagination();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;

        this.gridHelper.renderScrollArrow();
        this.gridHelper.autoTogglePagination();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.isSubmitButtonEnabled = this.gridOptions.api.getSelectedRows().length > 0;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '標準ケースコード',
        field: 'baracaseCd',
        width: this.getColumnWidth('baracaseCd', 150),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '標準ケース名',
        field: 'baracaseTx',
        width: this.getColumnWidth('baracaseTx', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '標準ケース入数',
        field: 'baraamountNr',
        width: this.getColumnWidth('baraamountNr', 150),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      }, 
      {
        headerName: '引当可能数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '入荷予定数',
        field: 'arrivepcsNr',
        width: this.getColumnWidth('arrivepcsNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '補充予定数',
        field: 'supppcsNr',
        width: this.getColumnWidth('supppcsNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '移動予定数',
        field: 'movepcsNr',
        width: this.getColumnWidth('movepcsNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '補充点',
        field: 'bsupppointbaraNr',
        width: this.getColumnWidth('bsupppointbaraNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '上限値',
        field: 'bsupplimitbaraNr',
        width: this.getColumnWidth('bsupplimitbaraNr', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
     ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    sessionStorage.removeItem('openWindow');
    this.ownerFormControl = new FormControl('0');
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa5030_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa5030_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa5030_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.working = true;

      this.ownerService
        .get()
        .then(outputJson => {
          this.working = false;
          this.owners = outputJson.owners;
        })
        .catch(error => {
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }, 500);
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    // this.overlayclose();
    this.loadingdspnone = false;
    if (this.ownerId !== 0) {
      setTimeout(() => {
        sessionStorage.removeItem('isShowOwnerSelect');
        // this.loadingdspnone = true;
        this.otherwindowdspnone = false;
      }, 1000);
    } else {
      // this.loadingdspnone = true;
      this.otherwindowdspnone = true;
    }

    this.nsuppService
      .get(this.ownerFormControl.value)
      .then(outputJson => {
        this.rowData = outputJson.results;
        this.showGrid = true;
        this.overlayclose();
        console.log('ok');
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.showGrid = false;
      });
    this.loadingdspnone = true;
  }

  commit() {
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    
    let ownerId: number;
    const selectIdSet = new Set<number>();
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = parseInt(this.gridOptions.api.getSelectedNodes()[i]['id']);
      ownerId = this.rowData[rowIndex]['ownerId'];
      selectIdSet.add(this.rowData[rowIndex]['itemId']);
    }
    
    this.nsuppService
      .confirm(ownerId, selectIdSet, 'wa5030')
      .then(outputJson => {
        this.ownerId = 0;
        this.onSubmit();
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

  }

  ngDoCheck() {
    if (this.isShow) {
      this.ownerId = this.ownerFormControl.value;
    }
    if (this.gridOptions.api) {
      this.selectedCount = this.gridOptions.api.getSelectedNodes().length;
    }
  }

  overlayclose() {
    this.closeButtonClick.emit(false);
  }

  otherwindowclose() {
    sessionStorage.setItem('isShowOwnerSelect', 'true');
    this.otherwindowdspnone = true;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.isSubmitButtonEnabled = false;

      var resetOwner = true;
      const ownerResult = sessionStorage.getItem('ownerResult');
      if (ownerResult !== null) {
        const selectedOwner = JSON.parse(ownerResult);
        if (selectedOwner.ownerId !== undefined) {
          this.ownerFormControl.setValue(selectedOwner.ownerId);
          this.ownerFormControl.disable();

          this.ownerFormControlCls = 'disabled';
          resetOwner = false;
          this.ownerId = selectedOwner.ownerId;
        }
      }
      if (resetOwner) {
        this.ownerFormControl.setValue('0');
        this.ownerFormControl.enable();
        this.ownerFormControlCls = '';
      }
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa5Move/wa5030/wa5030.component.ts